import ic_cross from '@/assets/images/icons/cross.svg';
import { Modal } from '@/components/shared';
import { bem } from '@/utilities';
import dayjs from 'dayjs';
import ja from 'dayjs/locale/ja';
import React from 'react';
import { Link } from 'react-router-dom';

dayjs.locale(ja);

type Props = {
  openModal: boolean;
  orderScheduledAt?: string;
  duration?: number;
  ordersLink: string;
  onClickCloseModal: () => void;
};

export const OrderCompletedModal: React.FC<Props> = (props) => {
  const { openModal, orderScheduledAt, duration, ordersLink, onClickCloseModal } = props;

  if (!openModal) return <></>;

  const formattedScheduledAtDate = () => {
    if (!orderScheduledAt || !duration) return '';
    return `${dayjs(orderScheduledAt).format('YYYY年MM月DD日（dd） HH:mm')}〜${dayjs(orderScheduledAt)
      .add(duration, 'm')
      .format('HH:mm')}`;
  };

  return (
    <Modal isOpen={openModal} onClickOverlay={() => onClickCloseModal()}>
      <div className={bem('modal', 'close-icon')} onClick={() => onClickCloseModal()}>
        <img src={ic_cross} />
      </div>
      <div className={bem('order-completed-modal', 'step')}>
        <div className={bem('order-completed-modal', 'step-first')}>内容確認</div>
        <div className={bem('order-completed-modal', 'step-bar')} />
        <div className={bem('order-completed-modal', 'step-second')}>予約完了</div>
      </div>
      <p className={bem('order-completed-modal', 'title')}>以下の日時で予約を確定しました</p>
      <p className={bem('order-completed-modal', 'schedule')}>{formattedScheduledAtDate()}</p>
      <div className={bem('order-completed-modal', 'notes')}>
        <p className={bem('order-completed-modal', 'notes-text')}>予約の日時は必ずお控えください。</p>
        <p className={bem('order-completed-modal', 'notes-text')}>
          ご予約内容は
          <Link to={ordersLink} className={bem('order-completed-modal', 'notes-link')}>
            予約履歴
          </Link>
          から再度確認できます。
        </p>
      </div>
      <button className={bem('order-completed-modal', 'button')} onClick={() => onClickCloseModal()}>
        閉じる
      </button>
    </Modal>
  );
};
